// initial state
const state = () => ({
    patchNotes: []
})

// getters
const getters = {
}

// actions
const actions = {
    getPatchNotes: async({ commit }) => {
        await axios.get('patch-note').then(({ data }) => {
            commit('setPatchNotes', data);
        }).catch((error) => {
            console.error('Error fetching patch notes:', error);
        });
    },

    updatePatchNotes: async({ state, commit }, patchNotes) => {
        console.log('updatePatchNotes', patchNotes, patchNotes.name);
        await axios.put('patch-note/' + patchNotes.id, patchNotes).then(({ data }) => {
            commit('updatePatchNote', data);
        }).catch((error) => {
            console.error('Error updating patch notes:', error);
        });
    },

    storePatchNotes: async({ state, commit }, patchNotes) => {
        console.log('storePatchNotes', patchNotes);
        await axios.post('patch-note', patchNotes).then(({ data }) => {
            commit('addPatchNote', data);
        }).catch((error) => {
            console.error('Error storing patch notes:', error);
        });
    },

    markPatchNoteSeen: async ({ state, commit }, inputData) => {
        console.log('markPatchNoteSeen', inputData);
        await axios.put('patch-note/' + inputData + '/mark-as-seen').then(({ data }) => {
            // commit('setPatchNotes', data);
        }).catch((error) => {
            console.error('Error marking patch note as seen:', error);
        });
    },
}

// mutations
const mutations = {
    setPatchNotes(state, payload) {
        state.patchNotes = payload;
    },

    updatePatchNote(state, payload) {
        let patchNote = state.patchNotes.find(patchNote => patchNote.id === payload.id);
        if (patchNote) {
            Object.assign(patchNote, payload);
        }
    },

    addPatchNote(state, payload) {
        state.patchNotes.push(payload);
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
